import { render, staticRenderFns } from "./SavedNode.vue?vue&type=template&id=4af0f901&scoped=true&"
import script from "./SavedNode.vue?vue&type=script&lang=js&"
export * from "./SavedNode.vue?vue&type=script&lang=js&"
import style0 from "./SavedNode.vue?vue&type=style&index=0&id=4af0f901&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af0f901",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VCol,VContainer,VDivider,VHover,VRow})
